<template>
	<Popup
		v-model="selfDisplay"
		title="成人互联邀请奖励"
		:confirmBtnDisplay="false"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row" style="padding: 0;">
				<el-date-picker
					v-model="startDate"
					:editable="false"
					class="b_inp"
					placeholder="开始日期"
					type="date"
					value-format="yyyy-MM-dd"
					@change="handleDateChange"
				>
				</el-date-picker>
				<el-date-picker
					v-model="endDate"
					:editable="false"
					class="b_inp"
					placeholder="结束日期"
					type="date"
					value-format="yyyy-MM-dd"
					style="margin-left: 20px;"
					@change="handleDateChange"
				>
				</el-date-picker>
			</div>
			<el-tabs v-model="tabName" type="card" style="margin-top: 15px;">
				<el-tab-pane :label="'一级奖励(' + summaryFirst + ')'" name="first"></el-tab-pane>
				<el-tab-pane :label="'二级奖励(' + summarySecond + ')'" name="second"></el-tab-pane>
			</el-tabs>
			<!-- 一级奖励 -->
			<div v-if="tabName == 'first'" class="base_table">
				<el-table
					:data="tableDataFirst"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="姓名"
					>
					</el-table-column>
					<el-table-column
						prop="mobile"
						label="手机号"
					>
					</el-table-column>
					<el-table-column
						prop="times"
						label="次数"
					>
					</el-table-column>
					<el-table-column
						prop="date"
						label="奖励日期"
					>
					</el-table-column>
				</el-table>
			</div>
			<!-- 一级奖励 end -->
			<!-- 二级奖励 -->
			<div v-if="tabName == 'second'" class="base_table">
				<el-table
					:data="tableDataSecond"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="姓名"
					>
					</el-table-column>
					<el-table-column
						prop="mobile"
						label="手机号"
					>
					</el-table-column>
					<el-table-column
						prop="times"
						label="次数"
					>
					</el-table-column>
					<el-table-column
						prop="date"
						label="奖励日期"
					>
					</el-table-column>
				</el-table>
			</div>
			<!-- 二级奖励 end -->
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../api/index.js';
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			uid: {
				type: String,
				default: ''
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data () {
			return {
				loading: false,
				selfDisplay: false,
				startDate: '',
				endDate: '',
				tabName: 'first',
				tableDataFirst: [],
				tableDataSecond: [],
				summaryFirst: 0,
				summarySecond: 0
			}
		},
		methods: {
			/***************** @Events ********************/
			// 改变时间
			handleDateChange() {
				this.compareDate();
				this.getData();
			},
			
			/***************** @Function ********************/
			// 获取数据
			getData() {
				const that = this;
				that.loading = true;
				var _requestData = {
					userId: that.uid,
					start: that.startDate,
					end: that.endDate
				};
				Api.getInviteReward(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						let data = res.data.data;
						let firstData = [];
						let secondData = [];
						data.levelOne.forEach(v => {
							firstData.push({
								name: v.uName,
								mobile: v.uCode,
								times: v.uTime,
								date: v.ucreateTs.split(' ')[0]
							});
						});
						data.levelTwo.forEach(v => {
							secondData.push({
								name: v.uName,
								mobile: v.uCode,
								times: v.uTime,
								date: v.ucreateTs.split(' ')[0]
							});
						});
						that.summaryFirst = data.totalOne;
						that.summarySecond = data.totalTwo;
						that.tableDataFirst = firstData;
						that.tableDataSecond = secondData;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 比较开始日期和结束日期
			compareDate() {
				if (this.startDate && this.endDate) {
					var startDate = new Date(this.startDate).getTime(),
						endDate = new Date(this.endDate).getTime();
					if (endDate < startDate) {
						this.endDate = '';
						this.$message.warning('结束日期不能小于开始日期');
					}
				}
			}
		},
		watch: {
			display (newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay (newVal) {
				this.$emit("changeDisplay", newVal);
				newVal && this.getData();
				if (!newVal) {
					this.loading = false;
					this.startDate = '';
					this.endDate = '';
					this.tabName = 'first';
					this.tabDataFirst = [];
					this.tabDataSecond = [];
					this.summaryFirst = 0;
					this.summarySecond = 0;
				}
			}
		}
	}
</script>

<style>
</style>
